export default "__VITE_ASSET__24ITzcvo__"